(() => {
  const MAIN_SELECTOR = 'img.product-gallery-deferred[data-main-image]';
  const STICKY_SELECTOR = 'img.product-sticky-gallery-deferred';

  const finish = (image) => {
    image.classList.remove('lazyloading');
    image.classList.add('lazyloaded');
    const loader = image.nextElementSibling;
    if (loader && loader.classList.contains('data-lazy-loading')) loader.remove();
  };

  const promote = (image) => {
    if (!image || (!image.matches(MAIN_SELECTOR) && !image.matches(STICKY_SELECTOR))) return;

    image.classList.add('lazyloading');
    image.loading = 'eager';
    image.setAttribute('fetchpriority', 'high');

    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      image.removeAttribute('data-srcset');
    }

    if (image.dataset.src) {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    }

    image.classList.remove('product-gallery-deferred', 'product-sticky-gallery-deferred');

    if (image.complete && image.currentSrc) {
      finish(image);
    } else {
      image.addEventListener('load', () => finish(image), { once: true });
      image.addEventListener('error', () => finish(image), { once: true });
    }
  };

  const promoteMainSlide = (slide) => {
    if (slide) promote(slide.querySelector(MAIN_SELECTOR));
  };

  const promoteThumbnailTarget = (thumbnail) => {
    if (!thumbnail) return;
    const thumbnailMediaId = thumbnail.getAttribute('data-media-id') || '';
    document.querySelectorAll('[data-image-gallery-main] .product-single__media[data-media-id]').forEach((media) => {
      if (thumbnailMediaId.endsWith('-' + media.getAttribute('data-media-id'))) {
        promote(media.querySelector(MAIN_SELECTOR));
      }
    });
  };

  const promoteStickyGallery = () => {
    document.querySelectorAll('.sticky-product-mobile ' + STICKY_SELECTOR).forEach(promote);
  };

  const handleIntent = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const thumbnail = target.closest('.productView-thumbnail[data-media-id]');
    if (thumbnail && !thumbnail.closest('.sticky-product-mobile')) {
      promoteThumbnailTarget(thumbnail);
    }

    if (target.closest('#show-sticky-product, [data-expand-sticky-add-to-cart]')) {
      promoteStickyGallery();
    }
  };

  const initialize = () => {
    document.querySelectorAll('[data-image-gallery-main]').forEach((gallery) => {
      if (!window.jQuery) return;
      window.jQuery(gallery)
        .off('beforeChange.phase3Gallery')
        .on('beforeChange.phase3Gallery', (_event, slick, _current, next) => {
          const slide = slick && slick.$slides ? slick.$slides.get(next) : null;
          promoteMainSlide(slide);
        });
    });

    document.addEventListener('pointerdown', handleIntent, true);
    document.addEventListener('click', handleIntent, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') handleIntent(event);
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
